export default (defaults = {}) => ({
  fields: [
    {
      defaultValue: defaults.name,
      label: 'Name',
      name: 'name',
      required: true,
      type: 'text'
    },
    {
      adminOnly: true,
      defaultValue: defaults.createdAt,
      label: 'Angelegt',
      name: 'createdAt',
      showAsDiv: true,
      type: 'datetime-local'
    },
    {
      adminOnly: true,
      defaultValue: defaults.updatedAt,
      hideTable: true,
      label: 'Zuletzt geändert',
      name: 'updatedAt',
      showAsDiv: true,
      type: 'datetime-local'
    }
  ],
  getLabel: ({ name }) => name,
  subject: {
    plural: 'Reitschulgruppen',
    singular: 'Reitschulgruppe'
  }
})
